import { createApiClient } from "#/shared/api/client";
import { validateRemotePage } from "#ce/components/SpQuantumSelect/composables/remote-pages";
import { fromSelect2Page } from "#ce/components/SpQuantumSelect/legacy/select2-page";

/** Returns a `(query, { page, signal })` loader that GETs `endpoint` with `q` and `page` set. */
export function createRemoteSearchApi(endpoint) {
  return async function loadRemote(query, { page, signal }) {
    const url = new URL(endpoint, location.href);
    url.searchParams.set("q", query);
    url.searchParams.set("page", String(page));

    const absolute = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(endpoint);
    const path = absolute ? url.href : `${url.pathname}${url.search}${url.hash}`;
    const api = createApiClient({ parse: false, baseURL: absolute ? undefined : path });

    return validateRemotePage(fromSelect2Page(await api.request("get", absolute ? path : "", { signal })));
  };
}
